import formatDate from 'date-fns/format';
import { createLocale } from 'react-localized';
export default createLocale(null, {
    formatDate: formatDate,
    formats: {
        date: 'MMMM d, yyyy'
    }
});
